var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_dowY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    fill: "#202020"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.62376795e-13,17.7206 C3.62376795e-13,17.1136 0.492,16.6206 1.1,16.6206 L19.101,16.6206 C19.708,16.6206 20.2,17.1136 20.2,17.7206 C20.2,18.3276 19.708,18.8206 19.101,18.8206 L1.1,18.8206 C0.492,18.8206 3.62376795e-13,18.3276 3.62376795e-13,17.7206",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2354,8.745 L10.9174,14.062 C10.4654,14.514 9.7344,14.514 9.2824,14.062 L3.9644,8.745 C3.5754,8.355 3.5754,7.724 3.9644,7.335 C4.3544,6.946 4.9854,6.946 5.3754,7.335 L9.1004,11.059 L9.1004,1 C9.1004,0.45 9.5494,0 10.1004,0 C10.6504,0 11.0994,0.45 11.0994,1 L11.0994,11.059 L14.8254,7.335 C15.2144,6.946 15.8454,6.946 16.2354,7.335 C16.6244,7.724 16.6244,8.355 16.2354,8.745",
    id: "Fill-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIc);
export default __webpack_public_path__ + "static/media/upload_ic.e12ccef1.svg";
export { ForwardRef as ReactComponent };